<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="90px" disabled="disabled">
      <el-form-item label="报表名称" prop="name" style="margin-right:15px">
        <el-input v-model.trim="form.name" placeholder="请输入报表名称" @change="(value)=>{form.name = value.replace(/\s/g,'')}" />
      </el-form-item>
      <el-form-item label="报表类型" prop="type" style="margin-right:15px">
        <el-select v-model="form.type" placeholder="请选择" clearable>
          <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="报表备注" prop="remark" style="margin-right:15px">
        <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注" />
      </el-form-item>
      <el-form-item label="是否是默认" prop="isDefault" style="margin-right:15px">
        <el-switch v-model.number="form.isDefault" active-color="#13ce66" inactive-color="#DDDDDD" :active-value="1" :inactive-value="0" />
      </el-form-item>
      <el-form-item label="创建人" prop="name" style="margin-right:15px">
        <el-input v-model="form.createdBy" placeholder="" />
      </el-form-item>
      <el-form-item label="创建时间" prop="name" style="margin-right:15px">
        <el-input v-model="form.gmtCreated" placeholder="" />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import request from "@/utils/request";

export default {
  name: "DiyReportEdit",
  data() {
    return {
      emptyForm: {},
      form: {
        code: "",
        branchCode: "",
        name: "",
        type: "",
        isDefault: "",
        remark: "",
      },
      rules: {
        name: [{ required: true, message: "请输入报表名称", trigger: "blur" }],
        remark: [
          {
            min: 1,
            max: 255,
            message: "长度在 1 到 255个字符",
            trigger: "blur",
          },
        ],
        type: [{ required: true, message: "请选择报表类型", trigger: "blur" }],
      },
      // 报表类型
      typeOptions: [
        { label: "运输单", value: 0, color: "gray" },
        { label: "订单", value: 1, color: "#0000ff" },
      ],
      // 是否默认
      isDefaultOptions: [
        { label: "否", value: 0, color: "gray" },
        { label: "是", value: 1, color: "#0000ff" },
      ],
    };
  },
  created() {
    //保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      //查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      request({ url: `/ntocc-tms-api/diyReport/${code}`, method: "get" }).then(
        (response) => {
          this.form = response.data;
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
.el-select {
  width: 100%;
}
</style>
